let HOST_NAME = window.location.hostname;
let PROTOCOL = window.location.protocol;
let HOST_PORT = window.location.port;

let URL_CTF_SERVICES = `https://${HOST_NAME}/ctf-services/`;
let URL_CTF_INTEGRACAO_PARCEIROS = `https://${HOST_NAME}/integracaoparceiro/`;
let SLOT_CTF_SERVICES = `ctf-services/`;
let SLOT_CTF_SERVICES_SUP = `ctf-servicesSup/`;

let URL_CARDS_VEICULO = `https://${HOST_NAME}/CardsVeiculo/`;
let URL_ONLINE = `https://${HOST_NAME}/online/`;
let URL_PORTAL = `https://${HOST_NAME}/portal/`;
let URL_PORTAL_CTF = `https://${HOST_NAME}/portalctf/`;
let URL_REPORT_PORTAL_UX = `https://${HOST_NAME}/ReportPortalCTFUX/`;
let URL_VEICULO_BLOQUEIO = `https://${HOST_NAME}/CtfVeiculoBloqueio/`;

switch (HOST_NAME) {
  case 'localhost':
    //https://homolog.portalctf.com.br/ctf-services/api/Posto/VerficarServicoDbTransContaDigitalAtivaAsync/0f237829-10a5-438b-949f-3460991442d7
    URL_CTF_SERVICES = `https://homolog.portalctf.com.br/ctf-services/`;
    //URL_CTF_SERVICES = `https://localhost:44331/`;
    URL_CTF_INTEGRACAO_PARCEIROS =
      'https://homolog.portalctf.com.br/integracaoparceiro/';

    URL_CARDS_VEICULO = 'https://homolog.portalctf.com.br/CardsVeiculo/';
    URL_ONLINE = 'https://homolog.portalctf.com.br/online/';
    URL_PORTAL = 'https://homolog.portalctf.com.br/Portal/';
    URL_PORTAL_CTF = 'https://homolog.portalctf.com.br/PortalCTF/';
    URL_REPORT_PORTAL_UX =
      'https://homolog.portalctf.com.br/ReportPortalCTFUX/';
    URL_VEICULO_BLOQUEIO =
      'https://homolog.portalctf.com.br/CtfVeiculoBloqueio/';
    break;

  case '172.17.0.88': // SRVWLPDPTLPRD05 STAGE
    URL_CTF_SERVICES = `172.17.0.88/ctf-services/`;
    URL_CTF_INTEGRACAO_PARCEIROS = '172.17.0.88/integracaoparceiro/';
    break;

  case '172.17.0.87': // SRVWLPDPTLPRD04
    URL_CTF_SERVICES = `172.17.0.87/ctf-services/`;
    URL_CTF_INTEGRACAO_PARCEIROS = '172.17.0.87/integracaoparceiro/';
    break;

  case '172.17.0.40': // SRVWLPDPTLPRD03
    URL_CTF_SERVICES = `172.17.0.40/ctf-services/`;
    URL_CTF_INTEGRACAO_PARCEIROS = '172.17.0.40/integracaoparceiro/';
    break;

  case '172.17.0.79': // SRVWLPDPTLPRD02
    URL_CTF_SERVICES = `172.17.0.79/ctf-services/`;
    URL_CTF_INTEGRACAO_PARCEIROS = '172.17.0.79/integracaoparceiro/';
    break;

  case 'portalctf.com.br':
  case 'www.portalctf.com.br':
    URL_CTF_SERVICES = `https://www.portalctf.com.br/ctf-services/`;
    URL_CTF_INTEGRACAO_PARCEIROS =
      'https://www.portalctf.com.br/integracaoparceiro/';
    break;

  case 'homolog.portalctf.com.br':
  case 'www.homolog.portalctf.com.br':
    window.location.pathname.toLowerCase().includes('sup')
      ? (URL_CTF_SERVICES = `https://${HOST_NAME}/${SLOT_CTF_SERVICES_SUP}`)
      : (URL_CTF_SERVICES = `https://${HOST_NAME}/${SLOT_CTF_SERVICES}`);

    console.log('URL_CTF_SERVICES', URL_CTF_SERVICES);

    URL_CTF_INTEGRACAO_PARCEIROS = `https://${HOST_NAME}/integracaoparceiro/`;
    break;

  default:
    console.log(
      `Hostname: ${PROTOCOL}://${HOST_NAME}:${HOST_PORT} não mapeado no arquivo env do projeto!`
    );
    break;
}

export const environment = {
  production: true,
  host_ctf_service: URL_CTF_SERVICES,
  host_ctf_integracao_parceiros: URL_CTF_INTEGRACAO_PARCEIROS,
  sistemas: {
    cardsveiculo_url: URL_CARDS_VEICULO,
    online_url: URL_ONLINE,
    portal_url: URL_PORTAL,
    portalctf_url: URL_PORTAL_CTF,
    reportportalctfux: URL_REPORT_PORTAL_UX,
    veiculobloqueio_url: URL_VEICULO_BLOQUEIO,
  },
};
